/* pages/Trash.jsx — deleted docs wait here for 30 days before they're gone for good. */

import { docs } from '../state.js';
import { restoreDoc, deleteForever } from '../sync/docs.js';
import { Button, confirmDialog, toast, timeAgo, Icon } from '../ui/ui.jsx';
import { Proto } from '../ui/proto.jsx';
import { TopBar } from './Home.jsx';

export function Trash() {
  const list = docs.value.filter(d => d.deletedAt && d.role === 'owner');
  return (
    <div class="home">
      <TopBar title="Trash" />
      <main id="main" class="home-main narrow">
        <div class="trash-head">
          <p class="hint">Docs in the trash are deleted for good 30 days after you put them here.</p>
          {list.length > 0 && <Button size="sm" icon="trash" kind="danger-plain" onClick={async () => {
            if (!await confirmDialog({ title: 'Empty the trash?', text: `${list.length} doc${list.length === 1 ? '' : 's'} and all their versions will be gone for good. This can't be undone.`, ok: 'Empty trash', danger: true })) return;
            let gone = 0;
            for (const d of list) { try { await deleteForever(d.id); gone++; } catch (err) { toast(err, { kind: 'error' }); break; } }
            if (gone) toast(gone === list.length ? 'Trash emptied.' : `Deleted ${gone} of ${list.length}.`);
          }}>Empty trash</Button>}
        </div>
        {!list.length ? <div class="empty"><Proto size={64} /><p>The trash is empty. Nice and tidy.</p></div> : (
          <ul class="doclist">
            {list.map(d => (
              <li class="docrow" key={d.id}>
                <div class="docrow-main">
                  <span class="docrow-icon"><Icon name="doc" size={20} /></span>
                  <span class="docrow-text">
                    <span class="docrow-title">{d.title || 'Untitled document'}</span>
                    <span class="docrow-snippet">Deleted {timeAgo(d.deletedAt)}</span>
                  </span>
                </div>
                <Button size="sm" icon="restore" onClick={() => restoreDoc(d.id).then(() => toast('Restored.'))}>Restore</Button>
                <Button size="sm" kind="danger-plain" onClick={async () => {
                  if (!await confirmDialog({ title: 'Delete for good?', text: `"${d.title || 'Untitled document'}" and all its versions will be gone. This can't be undone.`, ok: 'Delete for good', danger: true })) return;
                  deleteForever(d.id).then(() => toast('Deleted for good.')).catch(err => toast(err, { kind: 'error' }));
                }}>Delete for good</Button>
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}
